export default __webpack_public_path__ + "static/media/ios-start.80b7301a.svg";